// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"f7584427","174":"bcacc8a1","193":"900a3121","321":"9a7d83e0","889":"ed344497"}[chunkId] + ".chunk.js";
};